// these functions don't do anything special, they are used in the codebase for simple mocking

export const getStorageItem = (key: string): string =>
  localStorage.getItem(key)

export const removeStorageItem = (key: string): void =>
  localStorage.removeItem(key)

export const setStorageItem = (key: string, value: string): void =>
  localStorage.setItem(key, value)